import { getUsuariosLimitaciones } from 'api/usuarios/usuariosLimitaciones';
import store from 'store/store';
import { selectUser } from 'store/auth';

/**
 * Obtiene el paso de autorización (configuración de limitación) asignado al
 * usuario actualmente logueado para un flujo determinado (Nombramientos,
 * Contrataciones o Administración de Plazas).
 *
 * @param {(params: object) => Promise<object[]|{results: object[]}>} getLimitaciones
 *   Función de API que lista los pasos de autorización del flujo
 *   (ej. getLimitacionesAutorizacionNombramientos).
 * @returns {Promise<object|null>} El paso asignado al usuario, o null si no
 *   tiene ninguno configurado.
 */
export const obtenerMiPasoDeAutorizacion = async (getLimitaciones) => {
  try {
    const currentUserId = selectUser(store.getState())?.id;
    if (!currentUserId) return null;

    const uliData = await getUsuariosLimitaciones({ usuario: currentUserId });
    const uli = (uliData.results || uliData || [])[0];
    if (!uli) return null;

    const pasoData = await getLimitaciones({ usuarios_limitacion_de_informacion: uli.id });
    return (pasoData.results || pasoData || [])[0] || null;
  } catch (err) {
    return null;
  }
};

export default obtenerMiPasoDeAutorizacion;
